export const ZIP_VALIDATION_REGEX = /^\d\d\d\d\d$/;

export const NOT_EMPTY_STRING_REGEX = /^(?!\s*$).+/;
export const PRIVACY_URL = 'https://info.polco.us/privacy';
export const KNOWLEDGE_BASE_URL = 'https://info.polco.us/knowledge';
export const TERMS_OF_SALE_URL = 'https://info.polco.us/termsOfSale';
export const TERMS_OF_USE_URL = 'https://info.polco.us/terms-of-use';
export const GPAL_URL = 'https://info.polco.us/gpal';
